module.exports = __webpack_public_path__ + "media/home/Brush_Magenta-3cf19014.png";